const Hideable = (props) => {
    return !props.hidden && props.children;
}

export default Hideable;